
    import './styles.scoped.css';
    export default {
  "tabs-header": "awsui_tabs-header_14rmt_z28i8_187",
  "tabs-header-list": "awsui_tabs-header-list_14rmt_z28i8_193",
  "pagination-button": "awsui_pagination-button_14rmt_z28i8_208",
  "pagination-button-left": "awsui_pagination-button-left_14rmt_z28i8_213",
  "pagination-button-left-scrollable": "awsui_pagination-button-left-scrollable_14rmt_z28i8_216",
  "pagination-button-right": "awsui_pagination-button-right_14rmt_z28i8_220",
  "pagination-button-right-scrollable": "awsui_pagination-button-right-scrollable_14rmt_z28i8_223",
  "tabs-tab": "awsui_tabs-tab_14rmt_z28i8_228",
  "tabs-tab-label": "awsui_tabs-tab-label_14rmt_z28i8_239",
  "tabs-tab-link": "awsui_tabs-tab-link_14rmt_z28i8_255",
  "tabs-tab-disabled": "awsui_tabs-tab-disabled_14rmt_z28i8_314",
  "refresh": "awsui_refresh_14rmt_z28i8_332",
  "tabs-tab-active": "awsui_tabs-tab-active_14rmt_z28i8_346",
  "tabs-header-with-divider": "awsui_tabs-header-with-divider_14rmt_z28i8_353",
  "root": "awsui_root_14rmt_z28i8_357",
  "tabs": "awsui_tabs_14rmt_z28i8_187",
  "tabs-content": "awsui_tabs-content_14rmt_z28i8_374",
  "tabs-content-active": "awsui_tabs-content-active_14rmt_z28i8_378",
  "tabs-content-wrapper": "awsui_tabs-content-wrapper_14rmt_z28i8_388",
  "with-paddings": "awsui_with-paddings_14rmt_z28i8_388",
  "tabs-container-content-wrapper": "awsui_tabs-container-content-wrapper_14rmt_z28i8_392"
};
  